// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jbdsdzmyqkfbqijnoqmo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpiZHNkem15cWtmYnFpam5vcW1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxMDE5MTUsImV4cCI6MjA3MzY3NzkxNX0.t784M5dFHYwtzERYIifvfrTEUyXaXaCqxHPgdfGc4KY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});